"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isBrowser;

/**
 * Returns true when running in the browser, otherwise false.
 */
function isBrowser() {
  return typeof window !== 'undefined';
}
//# sourceMappingURL=isBrowser.js.map